import { wsService } from "./wsService";

var section = "maritime-agent-invoices";

function filter(param) {
  return wsService.make_post_request(section + "/filter", param);
}

function update(param = {}) {
  return wsService.make_post_request(section + "/update", param);
}


export const agenteMaritimaInvoiceService = {
  filter,
  update,
};
